import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=a68d0008&scoped=true&"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js&"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&id=a68d0008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68d0008",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VSpacer})
